module.exports = __webpack_public_path__ + "static/media/LoginMoneyButton.855cb9f2.PNG";